<template>
	<div class="taotiziyuan-container">
		<userHeader :isHideSearch="true" />
		<div class="banner">
			<div class="banner-content">
				<!-- Try to use an existing icon or a placeholder -->
				<div class="banner-logo-wrapper">
					<img src="@/assets/img/tinlike.svg" alt="logo" class="banner-logo" />
				</div>
				<div class="banner-text">
					<h1>安徽省普通高考英语听力计算机化考试</h1>
					<h2>在线模拟练习系统</h2>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="card-title">套题资源</div>
			
			<div class="toolbar">
				<div class="tab-group">
					<div 
						class="tab-btn" 
						:class="{ active: activeTab === 'self' }"
						@click="handleTabChange('self')"
					>自组机考</div>
					<div 
						class="tab-btn" 
						:class="{ active: activeTab === 'class' }"
						@click="handleTabChange('class')"
					>班级机考</div>
				</div>
				
				<div class="notice">
					{{ activeTab === 'self' ? '请选择两套不同的试题做为考试资源，点击A卷/B卷选择' : '请选择一套班级机考试题做为考试资源 (已含AB卷)' }}
				</div>
				
				<el-button type="success" class="start-btn" @click="startExam">开始考试</el-button>
			</div>
			
			<div class="paper-list">
				<div 
					v-for="(item, index) in listData" 
					:key="index" 
					class="paper-item"
					:class="{ striped: index % 2 === 0 }"
				>
					<div class="paper-name">{{ item.name }}</div>
					<div class="paper-actions">
						<template v-if="activeTab === 'self'">
							<div 
								class="select-btn" 
								:class="{ active: item.selected === 'A' }"
								@click="selectPaper(item, 'A')"
							>A卷</div>
							<div 
								class="select-btn" 
								:class="{ active: item.selected === 'B' }"
								@click="selectPaper(item, 'B')"
							>B卷</div>
						</template>
						<template v-else>
							<div 
								class="select-btn" 
								:class="{ active: item.selected }"
								@click="selectPaper(item, 'class')"
							>{{ item.selected ? '已选' : '选择' }}</div>
						</template>
					</div>
				</div>
			</div>
			
			<div class="pagination-container">
				<!-- Using element-ui pagination to mimic the design -->
				<el-pagination
					@current-change="handlePageChange"
					:current-page.sync="currentPage"
					:page-size="pageSize"
					layout="total, prev, pager, next, jumper"
					:total="total"
					background
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import userHeader from '@/components/hearder/userHeader.vue';

export default {
	name: 'taotiziyuan',
	components: {
		userHeader
	},
	data() {
		return {
			activeTab: 'self',
			currentPage: 1,
			pageSize: 10,
			total: 450, // Mock total
			listData: []
		};
	},
	created() {
		this.generateMockData();
	},
	methods: {
		handleTabChange(tab) {
			if (this.activeTab === tab) return;
			this.activeTab = tab;
			this.currentPage = 1;
			this.generateMockData();
		},
		generateMockData() {
			this.listData = [];
			if (this.activeTab === 'self') {
				this.listData = Array.from({ length: 10 }, (_, i) => ({
					id: i,
					name: i % 2 === 0 ? '2026年1月21日每日一听' : '2025年全国英语考试甲卷',
					selected: null // 'A' or 'B'
				}));
			} else {
				this.listData = Array.from({ length: 10 }, (_, i) => ({
					id: i,
					name: '高二一班自组A卷+高二一班自组B卷',
					selected: false // boolean
				}));
			}
		},
		selectPaper(item, type) {
			if (this.activeTab === 'self') {
				// Toggle selection
				if (item.selected === type) {
					item.selected = null;
				} else {
					// Enforce single selection per type (A or B)
					// If we are selecting 'A', find any other item that has 'A' selected and clear it
					// If we are selecting 'B', find any other item that has 'B' selected and clear it
					
					// Actually, the requirement is "Must select one set of A and one set of B, cannot multi-select".
					// This implies that across ALL rows, there can be only one 'A' selected and only one 'B' selected.
					// However, the current data structure is `item.selected = 'A' | 'B' | null`.
					// This means a single row can only have EITHER A OR B selected, not both.
					// If the requirement is "One A paper and One B paper", they might be from different rows.
					// But `item.selected` is a single string property.
					// If I select A on row 1, `row1.selected = 'A'`.
					// If I select B on row 2, `row2.selected = 'B'`.
					// This works fine.
					// But if I select A on row 3, `row1.selected` should probably be cleared if we want "single A".
					// Let's implement that: Single A and Single B across all rows.
					
					// First, if this item already has a selection (e.g. it was 'B' and we click 'A'), it just changes to 'A' (handled by `item.selected = type`).
					
					// Clear other items that have the same type selected
					this.listData.forEach(i => {
						if (i !== item && i.selected === type) {
							i.selected = null;
						}
					});
					
					item.selected = type;
				}
			} else {
				// For class exam, only one item can be selected at a time? 
				// Or can select multiple? The prompt implies "Please select ONE set".
				// So if we select this one, we should deselect others.
				const isSelected = item.selected;
				
				// Clear all others
				this.listData.forEach(i => i.selected = false);
				
				// Toggle current
				item.selected = !isSelected;
			}
		},
		startExam() {
			if (this.activeTab === 'self') {
				// Check if exactly one A and exactly one B are selected
				const selectedA = this.listData.filter(i => i.selected === 'A').length;
				const selectedB = this.listData.filter(i => i.selected === 'B').length;
				
				if (selectedA !== 1 || selectedB !== 1) {
					this.$message.warning('请选择一套A卷和一套B卷');
					return;
				}
				this.$message.success('开始自组机考');
				// Navigate to exam page
				this.$router.push('/shiting');
			} else {
				const selectedItem = this.listData.find(i => i.selected);
				if (!selectedItem) {
					this.$message.warning('请选择一套班级机考试题');
					return;
				}
				this.$message.success('开始班级机考');
				this.$router.push('/shiting');
			}
		},
		handlePageChange(val) {
			console.log(`当前页: ${val}`);
			// Here you would fetch data for the new page
			this.generateMockData(); 
		}
	}
};
</script>

<style lang="scss" scoped>
.taotiziyuan-container {
	min-height: 100vh;
	background: #f5f5f5;
	display: flex;
	flex-direction: column;

	.banner {
		height: 350px; /* Increased height to accommodate the layout */
		background: #0080ff; 
		background: linear-gradient(to right, #007bff, #0099ff);
		display: flex;
		justify-content: center;
		padding-top: 60px;
		box-sizing: border-box;
		
		.banner-content {
			display: flex;
			align-items: flex-start;
			color: #fff;
			position: relative;
			
			.banner-logo-wrapper {
				position: absolute;
				// top: -40px;
				left: -30px;
				transform: translateX(-100%);
				background: #fff;
				border-radius: 50%;
				padding: 10px;
				margin-right: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 80px;
				height: 80px;
				
				.banner-logo {
					width: 50px;
					height: 50px;
				}
			}
			
			.banner-text {
				margin-top: 5px;
				h1 {
					font-size: 36px;
					margin: 0;
					font-weight: bold;
					letter-spacing: 2px;
				}
				h2 {
					font-size: 28px;
					margin: 10px 0 0;
					font-weight: normal;
					text-align: center;
				}
			}
		}
	}

	.content {
		width: 1200px;
		margin: -150px auto 40px; /* Overlap banner */
		background: #fff;
		border-radius: 15px;
		padding: 30px;
		box-sizing: border-box;
		box-shadow: 0 4px 20px rgba(0,0,0,0.1);
		min-height: 600px;
		
		.card-title {
			text-align: center;
			color: #0080ff;
			font-size: 28px;
			font-weight: bold;
			margin-bottom: 30px;
		}
		
		.toolbar {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;
			padding: 10px 20px;
			background: #f9f9f9; /* Slight background for toolbar area if needed, or transparent */
			background: transparent;
			position: relative;
			
			.tab-group {
				display: flex;
				border: 1px solid #0080ff;
				border-radius: 4px;
				overflow: hidden;
				
				.tab-btn {
					padding: 8px 25px;
					cursor: pointer;
					background: #fff;
					color: #0080ff;
					font-size: 16px;
					transition: all 0.3s;
					
					&.active {
						background: #0080ff;
						color: #fff;
					}
					
					&:hover:not(.active) {
						background: #e6f1ff;
					}
				}
			}
			
			.notice {
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				color: #f56c6c;
				font-size: 14px;
				font-weight: bold;
			}
			
			.start-btn {
				padding: 10px 30px;
				font-size: 16px;
			}
		}
		
		.paper-list {
			margin-bottom: 30px;
			
			.paper-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 18px 30px;
				border-radius: 8px;
				margin-bottom: 12px;
				transition: background 0.2s;
				
				&.striped {
					background: #f0f2f5;
				}
				
				&:hover {
					background: #eef5fe;
				}
				
				.paper-name {
					font-size: 16px;
					color: #333;
					font-weight: 500;
				}
				
				.paper-actions {
					display: flex;
					gap: 15px;
					
					.select-btn {
						padding: 6px 20px;
						border: 1px solid #dcdfe6;
						border-radius: 4px;
						cursor: pointer;
						color: #606266;
						font-size: 14px;
						background: #fff;
						transition: all 0.2s;
						
						&:hover {
							border-color: #409eff;
							color: #409eff;
						}
						
						&.active {
							background: #409eff;
							color: #fff;
							border-color: #409eff;
						}
					}
				}
			}
		}
		
		.pagination-container {
			text-align: center;
			margin-top: 40px;
			
			::v-deep .el-pagination {
				font-weight: normal;
				.el-pager li {
					background: transparent;
					&.active {
						background-color: #0080ff;
						color: #fff;
					}
				}
			}
		}
	}
}
</style>